<template>
  <div>
    <spinner v-if="activateSpinner"></spinner>
    <div v-else>
      <div v-if="formType !== 'edit'">
        <div>
          <form-accordion :title="$t('common.security.pem')" :isTitleUpperCase="false" >
            <b-row class="d-flex form-group">
              <!--b-col sm="6" class="form-group">
                  <form-read-group-label-input :input-value="currentKeystore[0].pod" isMandatory
                    :inputLabel="$t('common.security.pod_select')" :placeholderValue="$t('common.security.pod_select')">
                  </form-read-group-label-input>
              </b-col-->
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :input-value="currentKeystore[0].name" isMandatory
                  :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
                </form-read-group-label-input>
              </b-col>
            </b-row>
          </form-accordion>
          <hr  class="mx-auto mb-4" />
          <form-accordion :title="$t('common.security.certificat')" :isTitleUpperCase="false">
            <b-row class="d-flex align-items-center form-group">
              <b-col sm="6" class="form-group mb-5">
                <form-read-group-label-input :inputValue="currentKeystore[0].startDate"
                  :inputLabel="$t('common.security.startDate')" :placeholderValue="$t('common.security.startDate')">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group mb-5">
                <form-read-group-label-input :inputValue="currentKeystore[0].endDate"
                  :inputLabel="$t('common.security.endDate')" :placeholderValue="$t('common.security.endDate')">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputValue="currentKeystore[0].deliveredBy"
                  :inputLabel="$t('common.security.deliveredBy')" :placeholderValue="$t('common.security.deliveredBy')">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputValue="currentKeystore[0].deliveredTo"
                  :inputLabel="$t('common.security.deliveredTo')" :placeholderValue="$t('common.security.deliveredTo')">
                </form-read-group-label-input>
              </b-col>
            </b-row>
          </form-accordion>
          <hr  class="mx-auto mb-4" />
          <form-accordion :title="$t('common.security.private_key')" :isTitleUpperCase="false">
            <b-row class="d-flex justify-content-center align-items-center form-group">
              <b-col sm="6" class="form-group mb-5">
                <form-read-group-label-input :input-value="currentKeystore[0].password"
                  :inputLabel="$t('common.security.password')" :placeholderValue="$t('common.security.password')">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group mb-5"></b-col>
            </b-row>
          </form-accordion>
        </div>

        <b-row class="justify-content-end form-group">
          <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('view')">
              <span>{{ $t('common.cncl') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('edit')">
              <i class="fa-light fa-pencil"></i>
              <span>{{ $t('administration.edit') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="deleteKeystore">
              <i class="fa-light fa-trash"></i>
              <span>{{ $t('rights.delete') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <keystore-form-pem :store="1" :keystore="currentKeystore[0]"></keystore-form-pem>
      </div>
    </div>
  </div>
</template>
<script>

import Spinner from '@/components/common/spinner.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import KeystoreFormPEM from "@/pages/security/KeystoreFormPEM.vue";

export default {
  name: 'KeystoreFormGlobal',
  components: {
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'spinner': Spinner,
    'keystore-form-pem': KeystoreFormPEM

  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    listCertificateOutGroup () {
      return this.listCertificates.filter(elem => {
        return !elem.inGroup
      })
    },
    listCertificateInGroup () {
      return this.listCertificates.filter(elem => {
        return elem.inGroup
      })
    }
  },
  data: () => {
    return {
      activateSpinner: true,
      currentKeystore: {},
      fields: [],
      formType: 'add',
      name: '',
      pageTitle: '',
      listCertificates: [],
      refreshTab: false
    }
  },
  created () {
    this.activateSpinner = true
    this.formType = this.mode
    this.getKeystore()
    this.fields.push({ key: 'name', tdClass: 'text-center '})
  },
  methods: {
    deleteKeystore() {
      let that = this

      this.$f7.modal({
        title: this.$t('common.security.keystore_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                id: that.id
              }
              that.$engine.security.keystore.delete(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.security.keystore_deleted'),
                  buttons: [
                    {
                      text: 'OK',
                      onClick: function () {
                        return
                      }
                    }
                  ]
                })
                loadPage(that, {url: '/security/1'})
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.security.ca_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    formHasError () {
      if (this.name.length === 0) {
        this.okMessageBox(this.$t('common.security.ca_name_missing'))
        return true
      }
      if (this.listCertificateInGroup.length === 0) {
        this.okMessageBox(this.$t('common.security.ca_cert_missing'))
        return true
      }
      return false
    },
    getKeystore(){
      let that = this
      this.$engine.security.keystore.fetch({id: this.id})
      .then(resp => {
        let keystore = {}

        keystore = resp.data.keystore

        that.currentKeystore = keystore

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRowSelectedInGroup (certificates) {
      for (let i = 0; i < this.listCertificateInGroup.length; i++) {
        this.listCertificateInGroup[i].selected = false
      }
      for (let i = 0; i < certificates.length; i++) {
        certificates[i].selected = true
      }
      /* this.selectCertificate(certificates[0]) */
    },
    onRowSelectedOutGroup (certificates) {
      for (let i = 0; i < this.listCertificateOutGroup.length; i++) {
        this.listCertificateOutGroup[i].selected = false
      }
      for (let i = 0; i < certificates.length; i++) {
        certificates[i].selected = true
      }
      /* this.selectCertificate(certificates[0]) */
    },
    selectCertificate(certificate){
      if(!this.isEditable){
        return
      }
      certificate.selected = !certificate.selected ? true : false
      this.refreshTab = !this.refreshTab
    },
    switchMode (mode) {
      this.formType = mode
    },
  }
}

</script>
